import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import ButtonLoader from "../components/Common/ButtonLoader/ButtonLoader";
import { getAuthVersion, sendForceUpdate } from "../../services/UserServices/UserService";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";

export default function ForceUpdate() {
  const [loader, setLoader] = useState(false);
  const [versionLoader, setVersionLoader] = useState(false);
  const [versionInfo, setVersionInfo] = useState(null);
  const [formData, setFormData] = useState({
    iosVersionCode: "",
    iosBuildNumber: "",
    androidVersionName: "",
    androidVersionCode: "",
  });

  const fetchVersionInfo = async () => {
    try {
      setVersionLoader(true);
      const response = await getAuthVersion();
      setVersionInfo(response?.data?.data ?? response?.data ?? null);
    } catch (error) {
      notifyError(error?.response?.data?.message || "Unable to fetch version info.");
    } finally {
      setVersionLoader(false);
    }
  };

  useEffect(() => {
    fetchVersionInfo();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      const response = await sendForceUpdate(formData);
      notifyTopRight("Force Update Sent Successfully.");
      fetchVersionInfo();
      setFormData({
        iosVersionCode: "",
        iosBuildNumber: "",
        androidVersionName: "",
        androidVersionCode: "",
      });

      setLoader(false);
    } catch (error) {
      setLoader(false);
      notifyError("Something went wrong please try again!");
    }
  };
  
  return (
    <div>
      <PageTitle activeMenu="Update" motherMenu="Force Update" />
      <Card>
        <Card.Body>
          <div style={{ marginBottom: "30px" }}>
            <div className="d-flex align-items-center justify-content-between">
              <h3 style={{ marginBottom: 0 }}>Current App / Store Version</h3>
            </div>

            <div style={{ marginTop: "15px" }}>
              {versionLoader ? (
                <div>Fetching version info...</div>
              ) : versionInfo ? (
                <>
                  <div className="row">
                    <div className="col-md-6" style={{ marginTop: "10px" }}>
                      <div className="border bg-white p-3" style={{ borderRadius: "8px" }}>
                        <h5>Android</h5>
                        <div>
                          <strong>Version Name:</strong>{" "}
                          {versionInfo?.androidVersionName ??
                            versionInfo?.android?.versionName ??
                            "-"}
                        </div>
                        <div>
                          <strong>Version Code:</strong>{" "}
                          {versionInfo?.androidVersionCode ??
                            versionInfo?.android?.versionCode ??
                            "-"}
                        </div>
                        {versionInfo?.androidStoreUrl || versionInfo?.android?.storeUrl ? (
                          <div style={{ marginTop: "8px" }}>
                            <strong>Play Store:</strong>{" "}
                            <a
                              href={versionInfo?.androidStoreUrl ?? versionInfo?.android?.storeUrl}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Open
                            </a>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="col-md-6" style={{ marginTop: "10px" }}>
                      <div className="border bg-white p-3" style={{ borderRadius: "8px" }}>
                        <h5>iOS</h5>
                        <div>
                          <strong>Build Number:</strong>{" "}
                          {versionInfo?.iosBuildNumber ??
                            versionInfo?.ios?.buildNumber ??
                            "-"}
                        </div>
                        <div>
                          <strong>Version Code:</strong>{" "}
                          {versionInfo?.iosVersionCode ??
                            versionInfo?.ios?.versionCode ??
                            "-"}
                        </div>
                        {versionInfo?.iosStoreUrl || versionInfo?.ios?.storeUrl ? (
                          <div style={{ marginTop: "8px" }}>
                            <strong>App Store:</strong>{" "}
                            <a
                              href={versionInfo?.iosStoreUrl ?? versionInfo?.ios?.storeUrl}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Open
                            </a>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div>No version info available.</div>
              )}
            </div>
          </div>

          <form onSubmit={onSubmit} style={{ marginTop: "50px" }}>
            <h3>Android</h3>
            <div
              className="input-group border bg-white input-group-sm"
              style={{ borderRadius: "8px" }}
            >
              <input
                style={{
                  paddingBottom: "25px",
                  paddingTop: "25px",
                  borderRadius: "10px",
                  fontSize: "14px",
                }}
                type="text"
                name="table_search"
                className="form-control float-right border-0"
                placeholder="Android Version Name"
                value={formData.androidVersionName}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    androidVersionName: e.target.value,
                  });
                }}
              />
            </div>
            <div
              className="input-group border bg-white input-group-sm"
              style={{ borderRadius: "8px", marginTop: "20px" }}
            >
              <input
                style={{
                  paddingBottom: "25px",
                  paddingTop: "25px",
                  borderRadius: "10px",
                  fontSize: "14px",
                }}
                type="text"
                name="table_search"
                className="form-control float-right border-0"
                placeholder="Android Version Code"
                value={formData.androidVersionCode}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    androidVersionCode: e.target.value,
                  });
                }}
              />
            </div>

            <h3 style={{ marginTop: "50px" }}>iOS</h3>
            <div
              className="input-group border bg-white input-group-sm"
              style={{ borderRadius: "8px" }}
            >
              <input
                style={{
                  paddingBottom: "25px",
                  paddingTop: "25px",
                  borderRadius: "10px",
                  fontSize: "14px",
                }}
                type="text"
                name="table_search"
                className="form-control float-right border-0"
                placeholder="Ios Build Number"
                value={formData.iosBuildNumber}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    iosBuildNumber: e.target.value,
                  });
                }}
              />
            </div>
            <div
              className="input-group border bg-white input-group-sm"
              style={{ borderRadius: "8px", marginTop: "20px" }}
            >
              <input
                style={{
                  paddingBottom: "25px",
                  paddingTop: "25px",
                  borderRadius: "10px",
                  fontSize: "14px",
                }}
                type="text"
                name="table_search"
                className="form-control float-right border-0"
                placeholder="Ios Version Code"
                value={formData.iosVersionCode}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    iosVersionCode: e.target.value,
                  });
                }}
              />
            </div>

            <div className="text-center" style={{ marginTop: "50px" }}>
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={loader}
              >
                {loader ? (
                  <>
                    <ButtonLoader /> Send
                  </>
                ) : (
                  "Send"
                )}
              </button>
            </div>
          </form>
        </Card.Body>
      </Card>
    </div>
  );
}
